import React, { Fragment, useMemo } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import get from "lodash/get";
import times from "lodash/times";
import toFinite from "lodash/toFinite";

import { addDays, parseISO, startOfDay } from "date-fns";

import RepeatField from "./InputTypes/RepeatField";

import { roundHours } from "../../utils/entry";

export default function DatesFields({ multiDayDurations: durations, multiDayTimeEntryDaySpan: daySpan, requiredFields, startDate, updateDurationMulti }) {
  const hasError = useMemo(() => requiredFields.includes("multiDay-duration"), [requiredFields]);

  const init = useMemo(() => startOfDay(startDate), [startDate]);

  const dates = useMemo(() => {
    return times(daySpan, function(i) {
      const date = addDays(init, i);

      const mdate = moment(date);

      const value = toFinite(get(durations, [i, "duration"], "0.0"));

      const onBlur = ({ target }) => {
        updateDurationMulti(roundHours(target.value), i, mdate);
      };

      const onChange = ({ target }) => {
        updateDurationMulti(target.value, i, mdate);
      };

      return (
        <RepeatField
          key={`field-${i}`}
          hasError={hasError}
          date={date}
          value={value}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    });
  }, [daySpan, durations, hasError, init, updateDurationMulti]);

  return <Fragment>{dates}</Fragment>;
}

DatesFields.displayName = "TimeInput.DatesFields";

DatesFields.propTypes = {
  requiredFields: PropTypes.arrayOf(PropTypes.string),
  startDate: PropTypes.instanceOf(Date).isRequired,
  updateDurationMulti: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/TimeInput/DatesFields.jsx